import React from 'react';
import { Box, Text } from '@marvelapp/ui';
export default function MoreCollaborators({ num, size }) {
    return (React.createElement(Box, { alignItems: "center", bg: "smoke", border: "3px solid", borderColor: "white", borderRadius: "50%", "data-testid": "extra-collaborators", display: "flex", height: size + 2, justifyContent: "center", position: "relative", pr: "2px", width: size + 2 },
        React.createElement(Text, { color: "slate", fontSize: (size + 2) / 3, fontWeight: 600, opacity: 0.7 },
            "+",
            num)));
}
